import dayjs from 'dayjs';

export type DateLike = Date | number | string;

const DEFAULT_CRITICAL_THRESHOLD_SEC = 5 * 60;

export const formatSecondsToMMSS = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return '00:00';
  }

  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export const isConferenceEndCritical = (
  secondsBeforeEnd: number,
  thresholdSec = DEFAULT_CRITICAL_THRESHOLD_SEC,
): boolean => {
  if (!Number.isFinite(secondsBeforeEnd)) {
    return true;
  }

  return secondsBeforeEnd <= thresholdSec;
};

export const getSecondsBeforeEnd = (
  endDate: DateLike,
  nowTs = Date.now(),
): number => {
  if (!endDate) {
    return 0;
  }

  return Math.max(0, dayjs(endDate).diff(dayjs(nowTs), 'second'));
};
